<script setup lang="ts">
interface LabeledCheckboxProperties {
  id: string;
  label: string;
}

defineProps<LabeledCheckboxProperties>();

const model = defineModel<boolean>({ default: false });
</script>

<template>
  <UiLabel
    :for="id"
    class="group -m-1.5 flex h-11 cursor-pointer items-center gap-2 rounded px-1.5 py-2 transition-colors hover:bg-gray-100"
  >
    <UiCheckbox
      :id="id"
      v-model="model"
      class="p-0.5"
    />
    <span class="min-w-0 flex-1 truncate text-sm text-foreground">{{ label }}</span>
    <span
      v-if="$slots.trailing"
      class="ml-auto flex shrink-0 items-center"
    >
      <slot name="trailing" />
    </span>
  </UiLabel>
</template>
